import type { ReferralsSnapshot } from "schemas/generated/bedrock";
import type { RequestFn } from "./request";

export function createReferralsClient({ request }: { request: RequestFn }) {
  return {
    get: () => {
      return request<ReferralsSnapshot>({
        method: "GET",
        path: "/api/v1/referrals",
      });
    },
  };
}
